.cloneToDeal {
  margin-top: 5px;
  margin-left: 25px;
}
